import { IConnectionService } from "@kase/my-marathon-communication";

const isConsole = localStorage.getItem("debug.console") === "true";
const isPerformance = localStorage.getItem("debug.performance") === "true";

export const onConnection = (con: IConnectionService | null) => {
    if (!con) {
        return;
    }

    if (isConsole || isPerformance) {
        con.setLogging({
            console: isConsole,
            performance: isPerformance,
        });
    }
};
